export default __webpack_public_path__ + "static/media/screenshot2.334bd11c.jpg";